'use strict';

class RcmFatProfile {
    constructor(fat) {
        this.fat = fat;

        // DOM
        this.profile = $('#fatv2-profile');
        this.profileBody = this.profile.children('.fatv2-profile-body');
        this.mapElement = null;

        // Selectors
        this.profileBodyLeftSelector = '.fatv2-profile-body-left';
        this.profileBodyRightMapSelector = '.fatv2-profile-body-right-map';
        this.profileBodyRightTextSelector = '.fatv2-profile-body-right-text';
        this.profileBodyRightBottomSelector = '.fatv2-profile-body-right-bottom';
        this.leftNavSelector = '.fatv2-profile-left-nav';
        this.rightNavSelector = '.fatv2-profile-right-nav';
        this.reportLinkSelector = '#fatv2-report-link';
    }

    // Show profile
    show(uniqueId, lat, lon, profileNotOnResults, externalData) {
        var self = this;

        // Data
        var data = null;
        var hasPrevProfile = true;
        var hasNextProfile = true;

        // Show a profile OUTSIDE the current search results
        if (profileNotOnResults && externalData) {
            data = externalData;
            hasPrevProfile = false;
            hasNextProfile = false;
        // Show a profile INSIDE the current search results
        } else {
            $.each(this.fat.data, function (index, value) {
                var page = value;

                $.each(page.hits, function (index2, value2) {
                    // $.each(value2._geoloc, function (index3, value3) {
                    var _uniqueId = self.fat._helperGetTeacherUniqueId(value2.objectID, value2._rankingInfo.matchedGeoLocation.lat, value2._rankingInfo.matchedGeoLocation.lng);

                    if (_uniqueId == uniqueId) {
                        data = value2;

                        // It doesn't have previous profile to navigate
                        if (index == 0 && index2 == 0) {
                            hasPrevProfile = false;
                        }

                        // It doesn't have next profile to navigate
                        var currentItemOnList = self.fat.resultsList.getItemObj(_uniqueId);
                        if (!currentItemOnList.next().hasClass('fatv2-results-list-item')) {
                            hasNextProfile = false;
                        }
                    }
                    // });
                });
            });
        }

        // If there is no profile with this ID on the data loaded
        if (!data) {
            alert('Profile not found');
            return;
        }

        // Populate global data object
        this.fat.dataProfile = data;

        // Clear profile
        this.profileBody.html('');

        // -- START / BASE --

        // Left navigation
        var leftNav = this.getLeftNav(data, hasPrevProfile);
        leftNav.appendTo(this.profileBody);

        // Right navigation
        var rightNav = this.getRighttNav(data, hasNextProfile);
        rightNav.appendTo(this.profileBody);

        // Structure
        var structure = this.getStructure(data);
        structure.appendTo(this.profileBody);

        // -- LEFT COLUMN --

        // Header (print, distance) ** ONLY SCREEN **
        var header = this.getHeader(data);
        header.prependTo(this.profileBody.find(this.profileBodyLeftSelector));

        // Description
        var description = this.getDescription(data);
        if (description != '') {
            description.insertAfter(this.profileBody.find('.fatv2-profile-header'));
        }

        // If it has selected to display profile
        if (data.showPublicProfileOptin) {
            // Instruments / Disciplines
            var disciplines = this.getDisciplines(data);
            if (disciplines != '') {
                disciplines.appendTo(this.profileBody.find('.fatv2-profile-body-left-left'));
            }

            // Spoken Languages
            var languages = this.getLanguages(data);
            if (languages != '') {
                languages.appendTo(this.profileBody.find('.fatv2-profile-body-left-left'));
            }

            // Specialized in
            var ageGroups = this.getAgeGroups(data);
            if (ageGroups != '') {
                ageGroups.appendTo(this.profileBody.find('.fatv2-profile-body-left-left'));
            }

            // Teaches at
            var teachingLocations = this.getTeachingLocations(data);
            if (teachingLocations != '') {
                teachingLocations.appendTo(this.profileBody.find('.fatv2-profile-body-left-left'));
            }

            // Specialist Designation
            var specialistDesignation = this.getSpecialistDesignation(data);
            if (specialistDesignation != '') {
                specialistDesignation.appendTo(this.profileBody.find('.fatv2-profile-body-left-right'));
            }

            // Credentials
            var credentials = this.getCredentials(data);
            if (credentials != '') {
                credentials.appendTo(this.profileBody.find('.fatv2-profile-body-left-right'));
            }

            // Professional Development
            var professionalDevelopment = this.getProfessionalDevelopment(data);
            if (professionalDevelopment != '') {
                professionalDevelopment.appendTo(this.profileBody.find('.fatv2-profile-body-left-right'));
            }

            // School Associations
            var schoolAssociations = this.getSchoolAssociations(data);
            if (schoolAssociations != '') {
                schoolAssociations.appendTo(this.profileBody.find('.fatv2-profile-body-left-right'));
            }

            // Website
            var website = this.getWebsite(data);
            if (website != '') {
                website.appendTo(this.profileBody.find('.fatv2-profile-body-left-right'));
            }
        }

        // -- RIGHT COLUMN --

        // Map
        var map = this.getMap(data, lat, lon);
        this.mapElement = map;
        map.appendTo(this.profileBody.find(this.profileBodyRightMapSelector));

        // Header (print, distance) ** ONLY PRINT **
        var header = this.getHeader(data);
        header.appendTo(this.profileBody.find(this.profileBodyRightTextSelector));

        // If it has selected to display profile
        if (data.showPublicProfileOptin) {
            // Address
            var address = this.getAddress(data);
            if (address != '') {
                address.appendTo(this.profileBody.find(this.profileBodyRightTextSelector));
            }
        }

        // If it has selected to display profile
        if (data.showPublicProfileOptin) {
            // Instruments / Disciplines ** ONLY PRINT **
            var disciplines = this.getDisciplines(data);
            if (disciplines != '') {
                disciplines.appendTo(this.profileBody.find(this.profileBodyRightTextSelector));
            }

            // Spoken Languages ** ONLY PRINT **
            var languages = this.getLanguages(data);
            if (languages != '') {
                languages.appendTo(this.profileBody.find(this.profileBodyRightTextSelector));
            }

            // Specialized in ** ONLY PRINT **
            var ageGroups = this.getAgeGroups(data);
            if (ageGroups != '') {
                ageGroups.appendTo(this.profileBody.find(this.profileBodyRightTextSelector));
            }

            // Teaches at ** ONLY PRINT **
            var teachingLocations = this.getTeachingLocations(data);
            if (teachingLocations != '') {
                teachingLocations.appendTo(this.profileBody.find(this.profileBodyRightTextSelector));
            }

            // RCM Credentials ** ONLY PRINT **
            var rcmCredentials = this.getRcmCredentials(data);
            if (rcmCredentials != '') {
                rcmCredentials.appendTo(this.profileBody.find(this.profileBodyRightTextSelector));
            }
        }

        // Form
        var formDisabled = document.getElementsByClassName("form-submit-disabled").length > 0 ? true : false;
        var form = this.fat.profileForm.get(data, formDisabled);
        form.insertBefore(this.profileBodyRightBottomSelector);

        // -- END --

        // Update captcha (form)
        if (data.acceptingNewStudents) {
            this.fat.google.renderRecaptcha();
        }

        // Open modal
        this.profile.foundation('open');

        // Update browser history
        this.fat.browser.updateHistory(true);

        // Update Report Issue link
        var reportLink = $(this.reportLinkSelector);
        if (reportLink) {
            reportLink.attr('href', this._helperGetReportURL(data));
        }

        // Update Google Analytics
        this.fat.google.updateGoogleAnalytics(data.objectID, true);

        if (Foundation.MediaQuery.is('large')) {
            map.css('height', header.outerHeight() + 'px');
        }

        // Console debug
        if (console && console.log) {
            console.log('RcmFatProfile.show', uniqueId, lat, lon, data);
        }
    }

    // Hide profile
    hide() {
        // Populate global data object
        this.fat.dataProfile = null;

        // Update browser history
        this.fat.browser.updateHistory();

        // Close modal
        this.profile.foundation('close');

        // Console debug
        if (console && console.log) {
            console.log('RcmFatProfile.hide');
        }
    }

    // Get structure HTML
    getStructure(data) {
        // HTML
        var html = `<div class="grid-x">
            <div class="cell small-12 large-6 fatv2-profile-body-left">
                <div class="tps-section">
                    <div class="tps-section-inner">
                        <div class="grid-x grid-margin-x">
                            <div class="tps-section-column cell medium-auto fatv2-profile-body-left-left"></div>
                            <div class="tps-section-column cell medium-auto fatv2-profile-body-left-right"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cell small-12 large-6 fatv2-profile-body-right">
                <div class="fatv2-profile-body-right-map"></div>
                <div class="fatv2-profile-body-right-text"></div>
                <div class="fatv2-profile-body-right-bottom"><a class="tps-link-with-icon-left" id="fatv2-report-link" href="${this._helperGetReportURL(data)}"><span class="far fa-flag"></span>Report an issue</a></div>
            </div>
        </div>`;

        html = $(html);
        return html;
    }

    // Get left navigation HTML
    getLeftNav(data, hasPrevProfile) {
        // HTML
        var html = `<a href="#" class="fatv2-profile-left-nav ${hasPrevProfile ? 'active' : ''}"><i class="far fa-chevron-left"></i></a>`;

        html = $(html);
        return html;
    }

    // Get right navigation HTML
    getRighttNav(data, hasNextProfile) {
        // HTML
        var html = `<a href="#" class="fatv2-profile-right-nav ${hasNextProfile ? 'active' : ''}"><i class="far fa-chevron-right"></i></a>`;

        html = $(html);
        return html;
    }

    // Get header HTML
    getHeader(data) {
        // Distance
        var distance = this.fat._helperTranslateDistance(data._rankingInfo.geoDistance);

        // HTML
        var html = `<div class="fatv2-profile-header">
            <span class="fatv2-profile-tag fatv2-profile-tag-style1"></span>
            <span class="fatv2-profile-tag fatv2-profile-tag-style2"></span>
            <div class="fatv2-profile-header-top">
                <a href="javascript:window.print()" class="fatv2-profile-print"><i class="fas fa-print"></i></a>
                <span class="fatv2-profile-distance">${distance.distance}<span>${distance.unit}</span></span>
            </div>
            <div class="fatv2-profile-content-top">
                <div class="fatv2-profile-photo ${data.profilePicture ? '' : 'no-photo'}"></div>
                <div class="fatv2-profile-content-top-text">
                    <p class="h2 fatv2-profile-title">${data.fullName}</p>`
                     + (data.teachingLocation && data.teachingLocation.includes('Oscar Peterson School of Music (Toronto)') ? `<div class="fatv2-profile-opstag">Faculty, Oscar Peterson School of Music</div>` : '') +
                    `<div class="fatv2-profile-rcm-credentials">${this.getRcmCredentials(data, false, false)}</div>
                </div>
            </div>
        </div>`;

        html = $(html);

        // Certified tag
        var elCert = html.find('.fatv2-profile-tag-style1');
        if (!data.isCertified) {
            elCert.remove();
        } else {
            var htmlCert = this._helperGetCertifiedTag(data);
            htmlCert.appendTo(elCert);
        }

        // Online Certified tag
        var elCert = html.find('.fatv2-profile-tag-style2');
        if (!data.isCertifiedOnline) {
            elCert.remove();
        } else {
            var htmlCert = this._helperGetCertifiedOnlineTag(data);
            htmlCert.appendTo(elCert);
        }

        // Profile picture
        if (data.profilePicture) {
            var imgSrc = `${this.fat._helperGetDrupalBaseUrl()}/${data.profilePicture}`;
            var imgHtml = `<img src="${imgSrc}" alt="${data.fullName}">`;
            html.find('.fatv2-profile-photo').html(imgHtml).css('background-image', `url(${imgSrc})`);
        } else {
            var photoTextHtml = this.fat._helperGetNameInitials(data);
            html.find('.fatv2-profile-photo').html(photoTextHtml);
        }

        return html;
    }

    // Get certified tag
    _helperGetCertifiedTag(data) {
        var html = `<span class="fatv2-profile-tag-inner">RCM CERTIFIED</span>`;
        html = $(html);
        return html;
    }

    // Get certified online tag
    _helperGetCertifiedOnlineTag(data) {
        var html = `<span class="fatv2-profile-tag-inner">CERTIFIED ONLINE TEACHER</span>`;
        html = $(html);
        return html;
    }

    // Get description HTML
    getDescription(data) {
        if (data.bio) {
            // HTML
            var html = `<p class="fatv2-profile-description">${data.bio}</p>`;

            html = $(html);
            return html;
        }

        return '';
    }

    // Get website HTML
    getWebsite(data) {
        if (data.teacherWebsite) {
            // href
            var href = data.teacherWebsite;
            if (!(new RegExp('^https?:\/\/')).test(href)) {
                href = `https://${href}`;
            }

            // HTML
            var html = `<div class="fatv2-profile-list fatv2-profile-website">
                <p class="fatv2-profile-list-label">Website</p>
                <p class="fatv2-profile-list-inner">
                    <a href="${href}" target="_blank">${data.teacherWebsite}</a>
                </p>
            </div>`;

            html = $(html);
            return html;
        }

        return '';
    }

    // Get instruments/disciplines HTML
    getDisciplines(data) {
        if (data.disciplines && data.disciplines.length > 0 && data.disciplines[0] != '') {
            var html = this._helperGetList(data.disciplines, 'disciplines', 'Instrument / Discipline');
            return html;
        }

        return '';
    }

    // Get spoken languages HTML
    getLanguages(data) {
        if (data.languages && data.languages.length > 0 && data.languages[0] != '') {
            var html = this._helperGetList(data.languages, 'languages', 'Spoken languages');
            return html;
        }

        return '';
    }

    // Get specialized in HTML
    getAgeGroups(data) {
        if (data.agesTaught && data.agesTaught.length > 0 && data.agesTaught[0] != '') {
            var html = this._helperGetList(data.agesTaught, 'age-groups', 'Specialized in');
            return html;
        }

        return '';
    }

    // Get teaches at HTML
    getTeachingLocations(data) {
        if (data.teachingLocation && data.teachingLocation.length > 0 && data.teachingLocation[0] != '') {
            var html = this._helperGetList(data.teachingLocation, 'teaching-locations', 'Lesson Location');
            return html;
        }

        return '';
    }

    // Get rcm credentials HTML
    getRcmCredentials(data, useWrapper = true, useSeparators = true) {
        if (data.rcmCredentials && data.rcmCredentials.length > 0 && data.rcmCredentials[0] != '') {
            var html = this._helperGetList(data.rcmCredentials, 'rcm-credentials', 'RCM Credentials', useWrapper, useSeparators);
            return html;
        }

        return '';
    }

    // Get specialist designation HTML
    getSpecialistDesignation(data) {
        if (data.designations && data.designations.length > 0 && data.designations[0] != '') {
            // HTML
            var html = this._helperGetListWrapper(data.designations, 'designations', 'Specialist designation');

            // Loop/list
            $(data.designations).each(function (index, value) {
                if (value != '') {
                    if (index > 0) {
                        html.children('.fatv2-profile-list-inner').append('<span class="fatv2-profile-list-separator"> / </span>');
                    }

                    html.children('.fatv2-profile-list-inner').append(`<span class="fatv2-profile-list-item">${value.subjectName} - ${value.levelName}</span>`);
                }
            });

            return html;
        }

        return '';
    }

    // Get credentials HTML
    getCredentials(data) {
        if (data.showCredentialsOptin && data.credentials && data.credentials.length > 0 && data.credentials[0] != '') {
            // HTML
            var html = this._helperGetListWrapper(data.credentials, 'credentials', 'Credentials');

            data.credentials.sort(function (a, b) {
                return parseInt(b.yearAwarded) - parseInt(a.yearAwarded);
            });

            // Loop/list
            $(data.credentials).each(function (index, value) {
                if (value != '') {
                    if (index > 0) {
                        html.children('.fatv2-profile-list-inner').append('<span class="fatv2-profile-list-separator"> / </span>');
                    }

                    html.children('.fatv2-profile-list-inner').append(`<span class="fatv2-profile-list-item">${value.yearAwarded} - ${value.degreeDiploma} - ${value.institution}</span>`);
                }
            });

            return html;
        }

        return '';
    }

    // Get professional development HTML
    getProfessionalDevelopment(data) {
        if (data.showProfessionalDevelopmentOptin && data.professionalDevelopment && data.professionalDevelopment.length > 0 && data.professionalDevelopment[0] != '') {
            // HTML
            var html = this._helperGetListWrapper(data.professionalDevelopment, 'professional-development', 'Professional development');

            // Loop/list
            $(data.professionalDevelopment).each(function (index, value) {
                if (value != '') {
                    if (index > 0) {
                        html.children('.fatv2-profile-list-inner').append('<span class="fatv2-profile-list-separator"> / </span>');
                    }

                    html.children('.fatv2-profile-list-inner').append(`<span class="fatv2-profile-list-item">${value.courseTitle} - ${value.description} - ${value.year}</span>`);
                }
            });

            return html;
        }

        return '';
    }

    // Get school associations HTML
    getSchoolAssociations(data) {
        if (data.showTeacherAssociationsOptin && data.associations && data.associations.length > 0 && data.associations[0] != '') {
            // HTML
            var html = this._helperGetListWrapper(data.associations, 'school-associations', 'School association(s)');

            // Loop/list
            $(data.associations).each(function (index, value) {
                if (value != '') {
                    if (index > 0) {
                        html.children('.fatv2-profile-list-inner').append('<span class="fatv2-profile-list-separator"> / </span>');
                    }

                    html.children('.fatv2-profile-list-inner').append(`<span class="fatv2-profile-list-item">${value.associationName} - ${value.associationTypeName}</span>`);
                }
            });

            return html;
        }

        return '';
    }

    // Get list HTML
    _helperGetList(data, htmlClass, label, useWrapper = true, useSeparators = true) {
        // HTML
        var html = useWrapper ? this._helperGetListWrapper(data, htmlClass, label) : '';

        // Loop/list
        $(data).each(function (index, value) {
            if (value != '') {
                if (index > 0 && useSeparators) {
                    html.children('.fatv2-profile-list-inner').append('<span class="fatv2-profile-list-separator"> / </span>');
                }
       
                var itemHtmlClass = '';

                // RCM Credentials
                if (label == 'RCM Credentials') {
                    // RCM Certified
                    if (value == 'RCM Certified') {
                        itemHtmlClass = 'is-certified';
                    } else if (value == 'Certified Online Teacher') {
                        itemHtmlClass = 'is-certified-online';
                        // RCM Examiner
                    } else if (value == 'RCM Examiner') {
                        itemHtmlClass = 'is-examiner';
                        // Teacher LRCM
                    } else if (value == 'Teacher LRCM') {
                        itemHtmlClass = 'is-lcrt';
                        // Teacher ARCT
                    } else if (value == 'Teacher ARCT') {
                        itemHtmlClass = 'is-arct';
                    } else if (value == 'RCM Smart Start Certified') {
                        itemHtmlClass = 'is-smart-certified';
                    } else if (value == 'Oscar Peterson School') {
                        return true;
                    }
                }

                if (useWrapper) {
                    html.children('.fatv2-profile-list-inner').append(`<span class="fatv2-profile-list-item ${itemHtmlClass}">${value}</span>`);
                } else {
                    html += `<span class="fatv2-profile-list-item ${itemHtmlClass}">${value}</span>`;
                }
            }
        });

        return html;
    }

    // Get list wrapper HTML
    _helperGetListWrapper(data, htmlClass, label) {
        // HTML
        var html = `<div class="fatv2-profile-list fatv2-profile-${htmlClass}">
            <p class="fatv2-profile-list-label">${label}</p>
            <p class="fatv2-profile-list-inner"></p>
        </div>`;

        html = $(html);
        return html;
    }

    // Get map
    getMap(data, lat, lon) {
        // HTML
        var html = `<div class="fatv2-profile-map"></div>`;
        html = $(html);

        // Google Map
        var gMap = new google.maps.Map(html[0], {
            zoom: 12,
            maxZoom: 14,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,
        });

        // Google LAT/LON
        var gLatLng = new google.maps.LatLng(lat, lon);

        // Center the map
        gMap.setCenter(gLatLng);

        // Create a marker for the teacher
        var gMarker = new google.maps.Marker({
            position: gLatLng,
            // animation: google.maps.Animation.DROP,
            // icon: FT.settings.mapMarkerCertTeacherUrl, // @TODO based on value.isCertified
            // icon: 'https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png',
        });

        // Addd the marker to the map
        gMarker.setMap(gMap);

        return html;
    }

    // Get map with multiple markers
    getMapWithMultipleMarkers(positions) {
        var self = this;

        // HTML
        var html = `<div class="fatv2-profile-map"></div>`;
        html = $(html);

        // Google Map
        var gMap = new google.maps.Map(html[0], {
            zoom: 12,
            maxZoom: 14,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,
        });

        // Bounds
        var gBounds = new google.maps.LatLngBounds();

        // Markers
        $(positions).each(function (index, value) {
            var uniqueId = self.fat._helperGetTeacherUniqueId(0, value.lat, value.lon);
            var gLatLng = new google.maps.LatLng(value.lat, value.lon);

            // Add marker to the bounds (to set the map zoom)
            gBounds.extend(gLatLng);

            // Create a marker for a teacher
            var gMarker = new google.maps.Marker({
                position: gLatLng,
                title: `${value.full_name} (${uniqueId})`,
                animation: google.maps.Animation.DROP,
                icon: value.is_certified ? `/RCM/assets/img/fat/v2/NTD_pin_certified.png?marker=1&uid=${uniqueId}` : `/RCM/assets/img/fat/v2/NTD_pin.png?marker=1&uid=${uniqueId}`, // This query string is important to be possible find the image later on DOM
            });

            // Addd the marker to the map
            gMarker.setMap(gMap);
        });

        // Add a listener to the map zoom change (avoid zoom bigger than 13 on results display)
        gMap.addListener('zoom_changed', function () {
            var zoomChangeBoundsListener = google.maps.event.addListener(gMap, 'bounds_changed', function (event) {
                if (this.getZoom() > 13 && this.initialZoom == true) {
                    this.setZoom(13);
                    this.initialZoom = false;
                }

                google.maps.event.removeListener(zoomChangeBoundsListener);
            });
        });
        gMap.initialZoom = true;

        // Set map zoom based on markers
        gMap.fitBounds(gBounds);

        return html;
    }

    // Get address HTML
    getAddress(data) {
        var self = this;

        // #22681164 - do not show addresses for anyone
        return '';
    }

    // Get address HTML (helper)
    _helperGetAddress(address) {
        // Full address
        var text = '';
        if ($.trim(address.addressName) != '') {
            text += address.addressName;
        }
        if ($.trim(address.street) != '') {
            text += ` ${address.street}`;
        }
        if ($.trim(address.city) != '') {
            text += `, ${address.city}`;
        }
        if ($.trim(address.province) != '') {
            text += ` ${address.province}`;
        }
        if ($.trim(address.country) != '') {
            text += `, ${address.country}`;
        }
        if ($.trim(address.postalCode) != '') {
            text += `, ${address.postalCode}`;
        }
        text = $.trim(text);

        if (text != '') {
            // HTML
            var html = `<span class="fatv2-profile-list-item">${text}</span>`;

            html = $(html);
            return html;
        }

        return '';
    }

    _helperGetReportURL(data) {
        return `/study-rcm/report-an-issue?teacherID=${encodeURIComponent(data.objectID)}&teacherName=${encodeURIComponent(data.fullName)}&teacherProfileURL=${encodeURIComponent(window.location.href)}&pageRef=Teacher%20Profile%20Modal`;
    }
} 
